import { render } from "./ClientInfos.vue?vue&type=template&id=ff76e808"
import script from "./ClientInfos.vue?vue&type=script&lang=js"
export * from "./ClientInfos.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__